export enum LanguageType {
  Hun = 'hun',
  Eng = 'eng',
}

export const uiLocales: Record<LanguageType, string> = {
  [LanguageType.Hun]: 'hu',
  [LanguageType.Eng]: 'en',
};
